import { Component, ContentChildren, EventEmitter, forwardRef, Input, OnInit, Output, QueryList } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Style } from '../../../models/common.enums';
import { RadioComponent } from './components/radio.component';

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.less'],
  providers: [{
    useExisting: RadioGroupComponent,
    provide: NG_VALUE_ACCESSOR,
    multi: true
  }]
})
export class RadioGroupComponent implements OnInit, ControlValueAccessor {
  @Input() name: string;
  @Input() title: string;
  @Input() isDisabled: boolean;
  @Input() isError: boolean;
  @Input() isUncheckable: boolean;
  @Input() value: string;
  @Input() displayStyle: Style = Style.horizontal;
 @Input() description: string;
  @ContentChildren(RadioComponent, { descendants: true }) private radioComponents: QueryList<RadioComponent>

  @Output() stateChanged: EventEmitter<any> = new EventEmitter();

  private onChange: any = () => { };
  private onTouch: any = () => { };

  constructor() { }

  ngOnInit(): void {
  }
  writeValue(value: any) {
    this.value = value;
    this.setRadioValue();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean) {
    if (this.radioComponents != null) {
      this.radioComponents.forEach((radio: RadioComponent) => {
        radio.isDisabled = isDisabled;
      })
    }
  }
  setRadioValue() {
    if (this.radioComponents != null) {
      this.radioComponents.forEach((radio: RadioComponent) => {
        radio.checked = this.value === radio.value;
      });
    }
  }
  updateValue(value: any) {
    this.value = value;
    this.setRadioValue();
    this.onChange(this.value);
    this.onTouch();
    this.stateChanged.emit(value);
  }
}
